import { CalendarClock, CheckCircle2, Clock3, Send } from "lucide-react";

// Mockup dimostrativo del canale SMS: dati sintetici, nessun fornitore citato.
const ROWS = [
  ["Promo weekend", "Sab 08:30", "Clienti fedeli", 1240, 1198, "Inviata"],
  ["Promemoria appuntamenti", "Oggi 09:00", "Lista dinamica", 86, 86, "Inviata"],
  ["Nuovi arrivi", "Lun 10:00", "Punto vendita Nord", 420, null, "Pianificata"],
];

export const SmsPreview = () => (
  <div className="rounded-2xl border !border-[#60A5FA]/30 !bg-[#0F172A] shadow-2xl shadow-black/40 overflow-hidden" data-testid="landing-sms-preview">
    <div className="flex items-center justify-between border-b border-slate-800 px-4 py-3">
      <p className="text-sm font-semibold text-white flex items-center gap-2"><Send className="h-4 w-4 text-[#60A5FA]" /> Campagne SMS</p>
      <span className="inline-flex items-center gap-1.5 rounded-full border border-[#60A5FA]/40 bg-[#60A5FA]/10 px-2.5 py-1 text-[11px] text-[#BFDBFE]"><CalendarClock className="h-3 w-3" /> Fascia oraria 08:00–20:00</span>
    </div>
    <ul className="divide-y divide-slate-800">
      {ROWS.map(([name, when, target, sent, dlr, state]) => (
        <li key={name} className="px-4 py-3 grid grid-cols-[1fr_auto] gap-3 items-center">
          <div className="min-w-0">
            <p className="text-sm font-medium text-white truncate">{name}</p>
            <p className="text-xs text-slate-400 truncate">{when} · {target} · {sent.toLocaleString("it-IT")} destinatari</p>
          </div>
          {dlr === null ? (
            <span className="inline-flex items-center gap-1 rounded-md bg-amber-500/15 px-2 py-1 text-[11px] text-amber-300"><Clock3 className="h-3 w-3" /> {state}</span>
          ) : (
            <span className="inline-flex items-center gap-1 rounded-md bg-emerald-500/15 px-2 py-1 text-[11px] text-emerald-300"><CheckCircle2 className="h-3 w-3" /> DLR {Math.round((dlr / sent) * 100)}%</span>
          )}
        </li>
      ))}
    </ul>
    <div className="grid grid-cols-3 divide-x divide-slate-800 border-t border-slate-800 text-center">
      {[["1.284", "consegnati"], ["42", "in coda"], ["€ 0,05", "costo per SMS"]].map(([v, l]) => (
        <div key={l} className="py-3"><p className="text-base font-bold text-white">{v}</p><p className="text-[11px] text-slate-400">{l}</p></div>
      ))}
    </div>
  </div>
);
